module.exports = __webpack_public_path__ + "files/ee3c30e4c6f75a89f3aa6bc41aa39b2a.png";